import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=50e7be66&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&id=50e7be66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7be66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e7be66')) {
      api.createRecord('50e7be66', component.options)
    } else {
      api.reload('50e7be66', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=50e7be66&scoped=true&", function () {
      api.rerender('50e7be66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/addKnowledge/upload/Upload.vue"
export default component.exports